import React from "react";
import { useNavigate } from "react-router-dom";
import { DefaultPageLayout } from "../../../../ui/layouts/DefaultPageLayout";
import { Button } from "../../../../ui/components/Button";
import { FeatherArrowLeft } from "@subframe/core";
import { PivotViewLibrary } from "./pivotBuilder/components/PivotViewLibrary";

export const PivotViewLibraryPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateNew = () => {
    navigate("/cfo/registers/uploadv1/create");
  };

  const handleBackToDashboard = () => {
    navigate("/cfo/dashboard");
  };

  return (
    <DefaultPageLayout>
      <div className="flex h-full w-full flex-col items-start">
        {/* Header */}
        <div className="flex w-full flex-col items-start gap-4 border-b border-solid border-neutral-border bg-default-background px-8 py-6">
          <div>
            <h1 className="text-heading-1 font-heading-1 text-default-font">
              Register - Upload
            </h1>
            <p className="text-body font-body text-subtext-color mt-2">
              Create and manage register configurations. Reuse saved views with new monthly data.
            </p>
          </div>
        </div>

        {/* Library Content */}
        <div className="flex-1 w-full overflow-auto bg-default-background p-8">
          <div className="flex w-full items-start mb-6">
            <Button
              variant="neutral-tertiary"
              icon={<FeatherArrowLeft />}
              onClick={handleBackToDashboard}
            >
              Go Back to Dashboard
            </Button>
          </div>
          <PivotViewLibrary onCreateNew={handleCreateNew} />
        </div>
      </div>
    </DefaultPageLayout>
  );
};

